import React from "react";
import LazyLoad from "react-lazyload";
import {
    supportCardData,
    supportCardLargeData,
} from "../../assets/Data/SupportSection";
import CardLarge from "./SupportCard/CardLarge";
import CardSmall from "./SupportCard/CardSmall";
import "./supportGamePlay.scss";

const SupportGamePlay = () => {
    return (
        <section className="container bgSecond support ">
            <div className="grid wide">
                <div className="textBox">
                    <h3 className="textBox__title">Supported Gameplay</h3>
                    <p className="textBox__text">
                        DOSE is the existing in-game currency of 22 Pushups,
                        which is separate from the DOSE ERC-20 token. In order
                        to expand the fitness metaverse, the team is planning to
                        link the two together, as well as adding DOSE to
                        Dustland Rider so players can use DOSE across platforms.
                    </p>
                </div>

                {supportCardData.map((item) => (
                    <LazyLoad key={item.id} height={50}>
                        <CardSmall item={item} />
                    </LazyLoad>
                ))}

                <LazyLoad height={50}>
                    <CardLarge card={supportCardLargeData} />
                </LazyLoad>
            </div>
        </section>
    );
};

export default SupportGamePlay;
